import queryString from 'query-string';
import Config from '../../../config';
let config;

/**
 * The Tessitura Proxy uses RPC format to handle error codes.
 * Rather than needing to check the status code we can instead
 * reject if there is a value for response.error
 *
 * Response in the form:
 * {
 *   id: '1', // JSONRPC-ism, can be ignored
 *   error: 'Some error', // null if OK
 *   result: {} // null if error
 * }
 */
function checkProxyStatus(response) {
  if (response.error === null && response.result !== null) {
    return response;
  } else if (response.error === null && response.result === null) {
    return [];
  } else {
    let err = new Error(response.error);
    err.response = response;
    throw err;
  }
}

/**
 * Handle session key injection
 * Replaces %sessionKey% placeholder with real session key
 */
function injectSessionKey(body, sessionKey) {
  if (body.hasOwnProperty('params')) {
    Object.keys(body.params).map(function(k) {
      if (body.params[k] === '%sessionKey%') {
        body.params[k] = sessionKey;
      }
      return k;
    });
  }
  if (body.hasOwnProperty('method')) {
    if (body.method.indexOf('%sessionKey%') !== -1) {
      body.method = body.method.replace('%sessionKey%', sessionKey);
    }
  }
  return body;
}

/**
 * Create a Request object for POST methods
 * - Content-Type is set to text/plain to avoid pre-flight request.
 * - Body must be stringified.
 */
function createPostRequest(endpoint, sessionKey, body) {
  config = new Config().getConfig();
  const reqBody = injectSessionKey(body, sessionKey);

  if (config.api_mode === 'REST') {
    return new Request(`${endpoint}/${body.method}`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(body.params)
    });
  } else {
    return new Request(endpoint, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'text/plain'
      }),
      body: JSON.stringify(reqBody)
    });
  }
}

/**
 * Create a Request object for GET methods
 *
 * GET with JSONRPC is really awkward.
 * - Content-Type is set to text/plain to avoid pre-flight request.
 * - 'id' and 'method' keys are passed as query parameters.
 * - Request Body params need to be Base64 encoded.
 */
function createGetRequest(endpoint, sessionKey, body) {
  config = new Config().getConfig();
  const reqBody = injectSessionKey(body, sessionKey);
  let params;

  if (config.api_mode === 'SOAP') {
    params = queryString.stringify(reqBody.params);
  } else if (body.params) {
    params = queryString.stringify(body.params);
  }

  let url = `${endpoint}/${body.method}`;

  if (params) {
    url = `${url}?${params}`;
  }

  return new Request(url, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  });
}

export {
  checkProxyStatus,
  injectSessionKey,
  createPostRequest,
  createGetRequest
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/common/helpers.js